import './src/css/global.css'
import React from 'react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'
import { prismicRepositoryConfigs } from './src/utils/prismic_repository_config'

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider repositoryConfigs={prismicRepositoryConfigs}>
    {element}
  </PrismicPreviewProvider>
)